import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchAllNewsPosts, deleteNewsPost } from '../../lib/newsPostsApi';

export default function NewsList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setPosts(await fetchAllNewsPosts());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    await deleteNewsPost(id);
    load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-brand-dark">News</h1>
          <p className="text-gray-500">Manage news articles.</p>
        </div>
        <Link
          to="/admin/news/new"
          className="bg-brand-purple text-white px-4 py-2 rounded-lg text-sm font-medium hover:opacity-90"
        >
          + New post
        </Link>
      </div>

      {loading ? (
        <p>Loading…</p>
      ) : posts.length === 0 ? (
        <p className="text-gray-500">No posts yet.</p>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left">
              <tr>
                <th className="p-4 font-medium">Title</th>
                <th className="p-4 font-medium">Date</th>
                <th className="p-4 font-medium">Status</th>
                <th className="p-4 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {posts.map((post) => (
                <tr key={post.id} className="border-t border-gray-100">
                  <td className="p-4">{post.title}</td>
                  <td className="p-4 text-gray-500">{new Date(post.date).toLocaleDateString()}</td>
                  <td className="p-4">
                    <span className={`px-2 py-0.5 rounded text-xs ${post.status === 'published' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                      {post.status}
                    </span>
                  </td>
                  <td className="p-4 text-right space-x-3">
                    <Link to={`/admin/news/${post.id}`} className="text-brand-purple hover:underline">Edit</Link>
                    <button type="button" onClick={() => handleDelete(post.id, post.title)} className="text-red-600 hover:underline">Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
